// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1___57dde747b4a193f68fe","cls2":"AutoCompleteResults-cls2___2f96b4a507ce6735a09 AutoCompleteResults-cls1___57dde747b4a193f68fe"};